'use client';
import { isSERVER } from '@/entities/cart/utils';

export const clearLocalStorageFavorites = () => {
  if (isSERVER) return;
  localStorage.removeItem('favorites');
};

export const addToLocalStorageFavorites = (productId: number) => {
  if (isSERVER) return;
  if (!productId) return;
  const prev = localStorage.getItem('favorites');
  if (!prev) {
    localStorage.setItem('favorites', JSON.stringify([productId]));
    return;
  }
  const arr = JSON.parse(prev);
  arr.push(productId);
  localStorage.setItem('favorites', JSON.stringify(Array.from(new Set(arr))));
};

export const removeFromLocalStorageFavorites = (productId: number) => {
  if (isSERVER) return;
  const prev = localStorage.getItem('favorites');
  if (!prev) {
    return;
  }
  const arr = JSON.parse(prev);
  const filtered = arr.filter((id: string) => Number(id) !== Number(productId));
  localStorage.setItem('favorites', JSON.stringify(filtered));
};

export const getLocalStorageFavorites = () => {
  if (isSERVER) return;
  const favorites = localStorage.getItem('favorites');
  if (!favorites) {
    return [];
  }
  return JSON.parse(favorites);
};

export const getLocalStorageFavoritesCount = () => {
  if (isSERVER) return;
  return getLocalStorageFavorites().length;
};

export const checkInFavoritesLocalStorage = (masterclassId?: number) => {
  if (isSERVER) return;
  if (!masterclassId) return false;
  const favorites = getLocalStorageFavorites();
  return favorites.includes(masterclassId);
};
